module.exports = __webpack_public_path__ + "img/bg-dots-3.89554940.svg";